<div class="d-flex justify-content-end mb-3 position-relative notifications-icon">
  <i
    class="bi bi-filter fs-4"
    role="button"
    (click)="openModal()"
    title="Filter Notifications"
  ></i>
  <span *ngIf="activeFilters.length > 0" class="filter-dot"></span>
</div>

<div *ngIf="isModalOpen" class="modal fade show" style="display: block;">
  <div class="modal-dialog modal-dialog-custom">
    <div class="modal-content">
      <div class="modal-body">
        <label class="form-label">{{ 'label.filters' | translate }}</label>
        <form [formGroup]="filtersForm">
          <app-checkbox-form-field
            *ngFor="let type of defaultFilters"
            [label]="type"
            [formControlName]="type"
          ></app-checkbox-form-field>
        </form>
      </div>
      <div class="modal-footer no-border">
        <button type="button" class="btn cancel-button" (click)="closeModal()">
          {{ 'buttons.cancel' | translate }}
        </button>
        <button type="button" class="btn apply-button" (click)="applyFilters()">
          {{ 'buttons.apply' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
